import React, {useEffect} from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import Login from './pages/Login';
import OlvidePassword from './pages/Login/OlvidePassword';
import RecuperarPassword from './pages/Login/RecuperarPassword';
import Home from './contenedor/Home';
import  {fetchUser}  from './utils/fetchUser';

import './App.css';
import { useStateContext } from './contexts/ContextProvider';


const App = () => {
  const {currentMode, setCurrentColor, setCurrentMode, activeMenu, currentColor, themeSettings, setThemeSettings, isAuthenticated, setIsAuthenticated } = useStateContext();

  const navigate = useNavigate();

  useEffect(() => {

  const User = fetchUser();

  if (!User) {
    navigate('/login');
  }

  }, []);

  return (

    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="olvidepassword" element={<OlvidePassword />} />
      <Route path="recuperarpassword" element={<RecuperarPassword />} />
      <Route path="/*" element={<Home />} />
    </Routes>

  );
};

export default App;